import { useState, useEffect } from "react"

const useTheme = () => {
  const [colourTheme, setColourTheme] = useState({ mode: "dark" })

  useEffect(() => {
    localStorage.setItem("colourTheme", JSON.stringify(colourTheme))
  }, [colourTheme])

  return {
    ...colourTheme,
    setTheme: ({ setTheme, ...colourTheme }) => setColourTheme(colourTheme),
  }
}

export default useTheme
